import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { createDiscussion } from '../../api/discussion api';

const AddDiscussionModal = ({ open, handleClose, uniqueTopics }) => {
  const user = useSelector((state) => state.users);
  const [newTopicInput, setNewTopicInput] = useState('');
  const [discussion, setDiscussion] = useState({ title: '', description: '', topic: '', userId: user.id });


  // Function to handle adding a new discussion
  const handleAddDiscussion = async () => {
    try {
      const topicToSubmit = discussion.topic || newTopicInput;
      await createDiscussion({ ...discussion, topic: topicToSubmit });
      setDiscussion({ title: '', description: '', topic: '', userId: '' });
      setNewTopicInput('');
      toast.success('Discussion added successfully!');
      handleClose();
    } catch (error) {
      toast.error('Failed to add discussion. Please try again.');
      console.error("Failed to add discussion:", error);
    }
  };
  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Add New Discussion</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            name="title"
            fullWidth
            value={discussion.title}
            onChange={(e) => setDiscussion({ ...discussion, title: e.target.value })}
            required
          />
          <TextField
            margin="dense"
            label="Description"
            name="description"
            fullWidth
            multiline
            rows={4}
            value={discussion.description}
            onChange={(e) => setDiscussion({ ...discussion, description: e.target.value })}
            required
          />
          <FormControl fullWidth variant="standard">
            <InputLabel>Topic</InputLabel>
            <Select
              value={discussion.topic}
              onChange={(e) => {
                const selectedTopic = e.target.value;
                setDiscussion({ ...discussion, topic: selectedTopic });
                if (selectedTopic !== '') {
                  setNewTopicInput('');
                }
              }}
            >
              {uniqueTopics.map((topic) => (
                <MenuItem key={topic} value={topic}>
                  {topic}
                </MenuItem>
              ))}
              <MenuItem value="">
                <em>Other</em>
              </MenuItem>
            </Select>
          </FormControl>

          {discussion.topic === '' && (
            <TextField
              margin="dense"
              label="New Topic"
              fullWidth
              variant="standard"
              value={newTopicInput}
              onChange={(e) => setNewTopicInput(e.target.value)}
              sx={{ marginTop: 2 }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleAddDiscussion} variant="contained" color="primary">
            Add Discussion
          </Button>
        </DialogActions>
      </Dialog>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default AddDiscussionModal;
